import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import * as models from '../../models';
import { OmnitureTags } from 'src/app/shared/omnitureTags';

@Component({
    providers: [OmnitureTags],
    selector: 'dd-app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppHeaderComponent implements OnInit {

  @Input() sharedData: models.SharedData;
  @Input() vehicleDetails: any;
  @Input() dealerDetails: any;

  constructor(public omTag: OmnitureTags
  ) { }

  ngOnInit() {

  }

}
